/* Dropdayz — filterdrawer op collectiepagina's.

   VERPLAATSEN NAAR BODY (detach): het thema zet een transform op
   #PageContainer. Een transform maakt van dat element het referentiepunt
   voor alles wat position:fixed is, en tegelijk een eigen stapelcontext.
   Gevolg als de drawer daarbinnen blijft staan: hij hangt niet aan het
   scherm maar aan de hele pagina (kop achter de header, knop onderaan buiten
   beeld) en de header wint altijd van onze z-index, hoe hoog we die ook
   zetten. Daarom hangen we hem bij het laden eenmalig direct onder body.

   Alles verder via gedelegeerde listeners op document, want de toolbar en het
   grid worden na elke filterwissel vervangen door verse server-HTML; directe
   listeners zouden dan stukgaan.

   De server is de enige bron van waarheid: bij elke wijziging halen we de
   echte URL op en nemen daaruit grid, toolbar, aantallen per maat en de
   knoptekst over. Geen tweede telling in JS die uit de pas kan lopen.

   ALLEEN DE SECTIE OPHALEN: met ?section_id= rendert Shopify uitsluitend de
   collectiesectie in plaats van de hele pagina met header, footer en alle
   scripts. Grid, toolbar en drawer zitten alle drie in die sectie, dus we
   hebben genoeg — en het scheelt op een pagina met 359 producten flink wat
   wachttijd per klik. Lukt dat niet, dan halen we alsnog de hele pagina op.

   TYPEN BESCHERMEN: het vervangen van de drawerinhoud zou een prijs die je
   net intypt overschrijven met de lege waarde van de server (het antwoord
   was al onderweg voordat jij begon te typen). Daarom zetten we na het
   vervangen het veld waar de cursor in stond terug zoals jij het had.

   UITKLAPSTAND: open blokken (merken, sorteren) zouden bij elke wissel weer
   dichtklappen omdat de inhoud opnieuw van de server komt. We onthouden per
   blok wat de bezoeker zelf openklapte en zetten dat terug. Alleen in het
   geheugen — een nieuwe pagina begint met de stand die het thema kiest.

   Een maat-pill kan meerdere checkboxes bevatten (EU 36 bestaat als "EU 36 -
   US 4" en "EU 36 - US 4.5"); die zetten we samen aan of uit, anders filter
   je maar op een deel van de voorraad. Het kruisje op een actieve chip in de
   toolbar doet hetzelfde via data-ddz-remove.

   sort_by zit als echte select in het formulier (werkt dus ook zonder JS),
   maar wordt hier uit de FormData gehaald en alleen toegevoegd als het
   afwijkt van de standaardsortering van de collectie — anders krijgt elke
   gefilterde URL er een overbodige ?sort_by bij, en die URLs worden gedeeld
   en geindexeerd.
*/
(function () {
  'use strict';

  var lastTrigger = null;
  var controller = null;
  var priceTimer = null;
  var collapsed = {};

  function drawer() { return document.getElementById('ddz-fdrawer'); }
  function form() { return document.getElementById('ddz-filter-form'); }

  function detach() {
    var el = drawer();
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  }

  function sectionId() {
    var el = document.querySelector('[data-section-type="collection-template"]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function restoreCollapse() {
    var all = document.querySelectorAll('[data-ddz-collapse]');
    for (var i = 0; i < all.length; i++) {
      var key = all[i].getAttribute('data-ddz-collapse');
      if (Object.prototype.hasOwnProperty.call(collapsed, key)) all[i].open = collapsed[key];
    }
  }

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    document.body.classList.add('ddz-fdrawer-lock');
    var panel = el.querySelector('.ddz-fdrawer__panel');
    if (panel) { try { panel.focus(); } catch (e) {} }
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.classList.remove('ddz-fdrawer-lock');
    window.setTimeout(function () {
      if (el && !el.classList.contains('is-open')) el.hidden = true;
    }, 320);
    if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} }
  }

  function chipByLabel(text) {
    var fm = form();
    if (!fm) return null;
    var all = fm.querySelectorAll('.ddz-fchip');
    for (var i = 0; i < all.length; i++) {
      var lbl = all[i].querySelector('.ddz-fchip__lbl');
      if (lbl && lbl.textContent.trim() === text) return all[i];
    }
    return null;
  }

  function uncheckChip(chip) {
    var boxes = chip.querySelectorAll('input[type=checkbox]');
    for (var i = 0; i < boxes.length; i++) boxes[i].checked = false;
    chip.classList.remove('is-on');
  }

  function clearAll() {
    var fm = form();
    if (!fm) return;
    var boxes = fm.querySelectorAll('input[type=checkbox]');
    for (var i = 0; i < boxes.length; i++) boxes[i].checked = false;
    var chips = fm.querySelectorAll('.ddz-fchip.is-on');
    for (var c = 0; c < chips.length; c++) chips[c].classList.remove('is-on');
    var nums = fm.querySelectorAll('input[type=number]');
    for (var j = 0; j < nums.length; j++) nums[j].value = '';
    apply();
  }

  function buildUrl() {
    var fm = form();
    var params = new URLSearchParams();
    if (fm) {
      var data = new FormData(fm);
      data.forEach(function (value, key) {
        if (key === 'sort_by') return;
        if (String(value).trim() !== '') params.append(key, value);
      });
    }
    var sort = document.getElementById('ddz-coll-sort-select');
    if (sort && sort.value && sort.value !== sort.getAttribute('data-ddz-default-sort')) {
      params.set('sort_by', sort.value);
    }
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function swap(doc, selector) {
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function optimisticBadge() {
    var fm = form();
    if (!fm) return;
    var n = fm.querySelectorAll('.ddz-fchip.is-on').length;
    var nums = fm.querySelectorAll('input[type=number]');
    var hasPrice = false;
    for (var i = 0; i < nums.length; i++) {
      if (String(nums[i].value).trim() !== '') hasPrice = true;
    }
    if (hasPrice) n += 1;
    var badge = document.querySelector('.ddz-coll-toolbar__fcount');
    var btn = document.querySelector('[data-ddz-filter-open]');
    if (!badge && btn && n > 0) {
      badge = document.createElement('span');
      badge.className = 'ddz-coll-toolbar__fcount';
      btn.appendChild(badge);
    }
    if (badge) {
      badge.textContent = n;
      badge.style.display = n > 0 ? '' : 'none';
    }
  }

  function render(html, url) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector('#Collection')) return false;

    var active = document.activeElement;
    var keepName = (active && active.name && active.type === 'number') ? active.name : null;
    var keepValue = keepName ? active.value : null;

    swap(doc, '#Collection');
    swap(doc, '.ddz-coll-toolbar');

    var freshBody = doc.querySelector('[data-ddz-filter-body]');
    var currentBody = document.querySelector('[data-ddz-filter-body]');
    if (freshBody && currentBody) {
      var keepScroll = currentBody.scrollTop;
      currentBody.innerHTML = freshBody.innerHTML;
      currentBody.scrollTop = keepScroll;

      if (keepName) {
        var again = currentBody.querySelector('input[name="' + keepName + '"]');
        if (again) {
          again.value = keepValue;
          try { again.focus(); } catch (e) {}
        }
      }
    }

    var freshApply = doc.querySelector('[data-ddz-filter-apply]');
    var currentApply = document.querySelector('[data-ddz-filter-apply]');
    if (freshApply && currentApply) currentApply.textContent = freshApply.textContent;

    detach();
    restoreCollapse();
    window.history.replaceState({ ddz: 1 }, '', url);
    return true;
  }

  function apply() {
    var el = drawer();
    var url = buildUrl();
    var id = sectionId();
    var fetchUrl = id ? (url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id)) : url;

    optimisticBadge();
    if (el) el.classList.add('is-busy');
    if (controller) { try { controller.abort(); } catch (e) {} }
    controller = ('AbortController' in window) ? new AbortController() : null;
    var signal = controller ? { signal: controller.signal } : {};

    window.fetch(fetchUrl, signal)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (render(html, url)) {
          if (el) el.classList.remove('is-busy');
          return null;
        }
        return window.fetch(url, signal).then(function (res) { return res.text(); });
      })
      .then(function (html) {
        if (!html) return;
        render(html, url);
        if (el) el.classList.remove('is-busy');
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (el) el.classList.remove('is-busy');
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var openBtn = e.target.closest('[data-ddz-filter-open]');
    if (openBtn) { e.preventDefault(); lastTrigger = openBtn; openDrawer(); return; }

    var closeBtn = e.target.closest('[data-ddz-filter-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }

    var clearBtn = e.target.closest('[data-ddz-filter-clear], .ddz-coll-toolbar__clear');
    if (clearBtn) { e.preventDefault(); clearAll(); return; }

    var removeChip = e.target.closest('.ddz-coll-toolbar__chip[data-ddz-remove]');
    if (removeChip) {
      var chip = chipByLabel(removeChip.getAttribute('data-ddz-remove'));
      if (chip) { e.preventDefault(); uncheckChip(chip); apply(); }
    }
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.hasAttribute || !d.hasAttribute('data-ddz-collapse')) return;
    collapsed[d.getAttribute('data-ddz-collapse')] = d.open;
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    if (t.id === 'ddz-coll-sort-select') { apply(); return; }

    var fm = form();
    if (!fm || !fm.contains(t) || t.type !== 'checkbox') return;

    var chip = t.closest ? t.closest('.ddz-fchip') : null;
    if (chip) {
      var boxes = chip.querySelectorAll('input[type=checkbox]');
      for (var i = 0; i < boxes.length; i++) boxes[i].checked = t.checked;
      chip.classList.toggle('is-on', t.checked);
    }
    apply();
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    var fm = form();
    if (!t || !fm || !fm.contains(t) || t.type !== 'number') return;
    window.clearTimeout(priceTimer);
    priceTimer = window.setTimeout(apply, 600);
  });

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'ddz-filter-form') { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var el = drawer();
    if (el && el.classList.contains('is-open')) closeDrawer();
  });

  window.addEventListener('popstate', function () { window.location.reload(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detach);
  } else {
    detach();
  }
})();
